import MarketPlace from '../../common/MarketPlace';

const ActivitiesPage = () => {
    return <MarketPlace />;
};

export default ActivitiesPage;
